import { createRoute } from '@tanstack/react-router';
import { loginParentRoute } from 'pages/shared/Login/loginParentRoute';

export const loginPasswordResetRoute = createRoute({
  getParentRoute: () => loginParentRoute,
  path: '/password/reset',
}).lazy(() => import('pages/shared/ResetPassword/SendEmail/SendEmail').then((d) => d.Route));
